import { useQuery } from '@tanstack/react-query';
import { candidateEducationService } from '../services/candidate-education.service';
import { useCandidateSession } from '../context/CandidateSessionContext';
import { useCandidateEducationMutations } from './useCandidateEducationMutations';
import type { CandidateEducationMutations } from './useCandidateEducationMutations';
import type { Education } from '@/features/educations/types/education.types';

interface CandidateEducationsResult extends CandidateEducationMutations {
  educations: Education[] | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export function useCandidateEducations(): CandidateEducationsResult {
  const { isAnonymous, shareId } = useCandidateSession();
  const queryKey = isAnonymous
    ? ['candidate-educations', 'anonymous', shareId]
    : ['candidate-educations'];

  const query = useQuery({
    queryKey,
    queryFn: () =>
      isAnonymous
        ? candidateEducationService.listByShareId(shareId!)
        : candidateEducationService.list(),
  });

  const mutations = useCandidateEducationMutations({ queryKey, isAnonymous, shareId });

  return {
    educations: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    ...mutations,
  };
}
